import UmlFreePoint from './UmlFreePoint';

// Class-naam/stereotype, of een connector-label. Losstaand versleepbaar tekstpunt.
class UmlCaption extends UmlFreePoint {
  constructor(id, x, y, text, stereotype) {
    super(id, x, y);
    this.text = text;
    this.stereotype = stereotype || null;
  }

  setText(text) {
    this.text = text;
  }
}

export default UmlCaption;
